import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  ReferenceField,
  FunctionField,
  EditButton,
  DeleteButton,
  TopToolbar,
} from "react-admin";

const ShipmentShowActions = () => (
  <TopToolbar>
    <EditButton />
    <DeleteButton />
  </TopToolbar>
);

export const ShipmentShow = () => (
  <Show actions={<ShipmentShowActions />}>
    <SimpleShowLayout>
      <TextField source="id" label="ID" />

      <DateField source="shipmentDate" label="Shipment Date" />

      <TextField source="trackingCode" label="Tracking Code" />

      <TextField source="plugNumber" label="Plug Number" />

      <ReferenceField
        source="productId"
        reference="products"
        label="Product"
        link="show"
      >
        <TextField source="name" />
      </ReferenceField>

      <ReferenceField
        source="licenseId"
        reference="licenses"
        label="License"
        link="show"
      >
        <FunctionField
          render={(record: any) =>
            `${record.serialNumber} - ${record.user?.name || "N/A"}`
          }
        />
      </ReferenceField>

      <DateField source="receiptDate" label="Receipt Date" emptyText="Not received yet" />

      <DateField source="createdAt" label="Created At" showTime />

      <DateField source="updatedAt" label="Updated At" showTime />
    </SimpleShowLayout>
  </Show>
);
